import React from "react";

const NoMatch = () => {
    return (
        <div className="row">
            <div className="col">
                <br />
                <br />
                <br />
                <br />
                <p className="fs-4 mt-6 text-danger">
                    Módulo no disponible en estos momentos
                </p>
            </div>
        </div>
    );
};

export default NoMatch;
